import { Layout } from "Components/Layout/Layout";
import { CapacitySearch } from "Containers/Capacity/Capacity";

import React from "react";

export const Capacity: React.FC = () => {
  return (
    <Layout>
      <CapacitySearch />
    </Layout>
  );
};
